import { reactive } from 'vue'
import { defineStore } from 'pinia'


export const useMessageStore = defineStore('messages', () => {
  const initialMessages:any = {
    logOutMessages:[],
    loggedInMessages:[]
  }

  const messages = reactive(initialMessages)

  function resetMessages() {
    Object.assign(messages, initialMessages)
  }

  function saveToCacheStore(data: any) {
    messages.loggedInMessages = data.messages;
  }

  return { messages, resetMessages, saveToCacheStore }
})
